import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "imagecanvas" };
var _hoisted_2 = { class: "image-title" };
var _hoisted_3 = ["src"];
var _hoisted_4 = ["src"];
import { ref, onMounted } from 'vue';
import { Modal } from "flowbite-vue";
import { initFlowbite } from "flowbite";
export default /*#__PURE__*/ _defineComponent({
    __name: 'taccuinoView',
    emits: ["cancel"],
    setup: function (__props, _a) {
        var __expose = _a.expose, emit = _a.emit;
        var showConfirm = ref(false);
        var imageDataBackUrl = ref('');
        var imageDataUrl = ref('');
        var resolvePromise;
        onMounted(function () {
            initFlowbite();
        });
        function openModal(message, imageurl, backurl) {
            imageDataBackUrl.value = backurl;
            imageDataUrl.value = imageurl;
            showConfirm.value = true;
            return new Promise(function (resolve) {
                resolvePromise = resolve;
            });
        }
        function closeModal() {
            showConfirm.value = false;
            if (!resolvePromise)
                return;
            resolvePromise(false);
            emit("cancel");
        }
        __expose({ openModal: openModal });
        return function (_ctx, _cache) {
            return (showConfirm.value === true)
                ? (_openBlock(), _createBlock(_unref(Modal), {
                    key: 0,
                    onClose: _cache[0] || (_cache[0] = function ($event) { return (showConfirm.value = false); })
                }, {
                    body: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("p", null, _toDisplayString(_ctx.$t("Immagine di anteprima")), 1)
                            ]),
                            _createElementVNode("div", null, [
                                _createElementVNode("img", {
                                    src: imageDataUrl.value,
                                    alt: "Test",
                                    style: { "width": "30%" }
                                }, null, 8, _hoisted_3),
                                _createElementVNode("img", {
                                    src: imageDataBackUrl.value,
                                    alt: "Test",
                                    style: { "width": "30%" }
                                }, null, 8, _hoisted_4)
                            ])
                        ])
                    ]; }),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
